import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

export enum UserTypeEnum {
  普通用户 = 0,
  候选人视角 = 1,
}

export async function uploadImg(params) {
  const resp = await http.post('/live/misc/upload_img', {
    ...params,
    ...window.store.getState().env.deviceinfo,
  })
  return resp.data.data
}

export const influential_user_vote = createAsyncThunk(
  'MonthlyInfluence/influential_user_vote',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/gift/influential_user_vote',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export const homepage = createAsyncThunk(
  'MonthlyInfluence/influential_user_homepage',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/gift/influential_user_homepage',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const influential_user_rank = createAsyncThunk(
  'MonthlyInfluence/influential_user_rank',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/gift/influential_user_rank',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const influential_user_search = createAsyncThunk(
  'MonthlyInfluence/influential_user_search',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/gift/influential_user_search',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const influential_user_share = createAsyncThunk(
  'MonthlyInfluence/influential_user_share',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/gift/influential_user_share',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const influential_user_records = createAsyncThunk(
  'MonthlyInfluence/influential_user_records',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/gift/influential_user_records',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)
export const influential_user_reward_wall = createAsyncThunk(
  'MonthlyInfluence/influential_user_reward_wall',
  async (params: any, store: any) => {
    const resp = await http.post(
      '/live/gift/influential_user_reward_wall',
      {
        ...params,
      },
      {store, xcErrorToast: true}
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  home: any
  base: any
  honor: any
}

const initialState: InitialStateType = {
  home: {},
  base: {},
  honor: {},
}

export const MonthlyInfluenceSlice = createSlice({
  name: 'MonthlyInfluenceSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, {
        home: {
          ...state.home,
          ...action.payload,
        },
      })
    })
    builder.addCase(influential_user_rank.fulfilled, (state, action) => {
      Object.assign(state, {
        home: {
          ...state.home,
          rankInfo: action.payload,
        },
      })
    })
    builder.addCase(influential_user_records.fulfilled, (state, action) => {
      Object.assign(state, {
        home: {
          ...state.home,
          recordInfo: action.payload,
        },
      })
    })
    builder.addCase(influential_user_reward_wall.fulfilled, (state, action) => {
      Object.assign(state.honor, action.payload)
    })
  },
})
export default MonthlyInfluenceSlice.reducer
export const MonthlyInfluenceActions = MonthlyInfluenceSlice.actions

export const useMonthlyInfluenceState = () => {
  const data = useSelector((state) => {
    return state.MonthlyInfluence
  })
  return data
}
